import React, { useContext } from 'react';
import { DishesContext, IDishesContext } from '../../../dishesState/dishesContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString, dishes } = useContext<IDishesContext>(DishesContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={dishes.dishesCount ? 800 : undefined}
		/>
	);
};

export default Search;
